import { Link } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { showError, showSuccess } from '@/lib/alert'
import { usePageTitle } from '@/hooks/usePageTitle'
import { ShowMoreLink, VacancyListPage } from '@/features/profile/VacancyListPage'

/**
 * Port of Views/Profile/SavedVacancy.cshtml +
 * wwwroot/js/app/profile/savedVacancy.js.
 *
 * BUG FIXED: the card footer linked to `/Vacancy/Info/{rawId}` and
 * `/Vacancy/Form/{rawId}` — raw integer ids on the two routes that expect the
 * AES-encoded one, so both buttons threw in DecodeId and bounced the candidate
 * back to the listing. They now go through `/Vacancy/InfoRedirect/{id}` and
 * `/Vacancy/Apply/{id}`, the bounce routes that exist for exactly this. Same
 * defect as the two Program pages.
 */
export function SavedVacancy(): JSX.Element {
  usePageTitle('Saved Vacancy')
  const queryClient = useQueryClient()

  async function unsave(trxVacancyID: number): Promise<void> {
    try {
      await api.del('/api/ecareer/vacancy/unsavedVacancy', { vacancyId: trxVacancyID })
      // The row leaves this list entirely once unsaved.
      await queryClient.invalidateQueries({ queryKey: ['profile-list'] })
      await showSuccess('Vacancy removed from saved list')
    } catch (error) {
      await showError(error instanceof Error ? error.message : 'Failed to remove saved vacancy')
    }
  }

  return (
    <VacancyListPage
      listUrl="/api/ecareer/vacancy/listSaved"
      careerUrl="/api/ecareer/career/listSaved"
      companyUrl="/api/ecareer/company/listSaved"
      positionUrl="/api/ecareer/position/listSaved"
      renderHeaderAction={(vacancy) => (
        <button
          type="button"
          className="btn btn-link btnSaveVacancy saved position-absolute top-0 end-0 mt-2 me-2 p-1"
          data-vacancy-id={vacancy.trxVacancyID}
          title="Remove from saved"
          onClick={() => void unsave(vacancy.trxVacancyID)}
        >
          <i className="fas fa-bookmark text-primary" style={{ fontSize: '1.5rem' }} />
        </button>
      )}
      renderFooter={(vacancy) => (
        <>
          <ShowMoreLink trxVacancyID={vacancy.trxVacancyID} />
          <Link
            to={`/Vacancy/Apply/${vacancy.trxVacancyID}`}
            className="btn btn-primary btnApplyNow"
            data-vacancy-id={vacancy.trxVacancyID}
          >
            Apply Now
          </Link>
        </>
      )}
    />
  )
}
